// extracted by mini-css-extract-plugin
module.exports = {"Loader":"_2ght3tvs13frZNbDGTevsm","spin":"_3VvjoaZtJM6VKXQF_RLNd3"};